import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const VARIANTS = {
  primary: "bg-ink text-paper hover:bg-accent hover:text-accent-ink",
  accent: "bg-accent text-accent-ink hover:bg-ink hover:text-paper",
  light: "bg-paper text-ink hover:bg-surface",
  ghost: "border border-ink/30 text-ink hover:border-ink hover:bg-ink hover:text-paper",
};

// Square spec button with sliding arrow. Pass `to` for internal routes or `href` for external links.
export const ButtonLink = ({ to, href, children, variant = "primary", className = "", testId, ...rest }) => {
  const cls = `group inline-flex items-center gap-3 rounded-none px-6 py-3.5 text-[15px] font-semibold tracking-[-0.005em] transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.98] ${VARIANTS[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <span className="relative grid h-5 w-5 place-items-center overflow-hidden">
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-5 group-hover:translate-x-5" />
        <ArrowUpRight className="absolute h-4 w-4 -translate-x-5 translate-y-5 transition-transform duration-300 group-hover:translate-x-0 group-hover:translate-y-0" />
      </span>
    </>
  );
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testId} target="_blank" rel="noopener noreferrer" {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testId} {...rest}>
      {inner}
    </Link>
  );
};
